// Apps service
import api from './authService'

export interface App {
  id: string
  bundle_id: string
  name: string
  icon_url: string | null
  current_version: string | null
  platform: 'ios' | 'macos' | 'visionos' | 'tvos' | 'watchos' | 'android'
  category: string | null
  created_at: string
  last_event_received_at: string | null
  is_active: boolean
  include_in_portfolio: boolean
}

export interface CreateAppRequest {
  bundle_id: string
  name: string
  platform: 'ios' | 'macos' | 'visionos' | 'tvos' | 'watchos' | 'android'
  current_version?: string
}

export interface CreateAppResponse extends App {
  api_key?: string
  warning?: string
}

export const appsService = {
  /**
   * Get all apps for the authenticated account
   */
  async getApps(): Promise<App[]> {
    const response = await api.get('/api/apps')
    return Array.isArray(response.data) ? response.data : response.data.apps
  },

  /**
   * Get single app by ID
   */
  async getApp(id: string): Promise<App> {
    const response = await api.get(`/api/apps/${id}`)
    return response.data
  },

  /**
   * Create a new app
   * Returns the app along with a generated API key (shown only once)
   */
  async createApp(data: CreateAppRequest): Promise<CreateAppResponse> {
    const response = await api.post('/api/apps', data)
    return response.data
  },

  /**
   * Update app details
   */
  async updateApp(id: string, data: Partial<App>): Promise<App> {
    const response = await api.put(`/api/apps/${id}`, data)
    return response.data
  },

  /**
   * Delete app
   */
  async deleteApp(id: string): Promise<void> {
    await api.delete(`/api/apps/${id}`)
  },
}
